import React from 'react';
import { Bug } from 'lucide-react';
import gdpr_flow from "./items/gdpr_flow.js";
import unicorn_flow from "./items/unicorns_items.js";
import Footer from "./components/footer.jsx";
import DawidHeader from "./components/header.jsx";
import './layout.css';
import { FORM_CLASS } from "./components/item.jsx";
import { Alert, AlertTitle, AlertDescription } from "./components/ui/alert";

const flows = [gdpr_flow, unicorn_flow];

export default function ErrorLayout({ errorInfo }) {
  return (
    <div>
      <style>{`html, body { background: #eee; }`}</style>
      <div id="content">
        <DawidHeader resetSession={() => window.location.reload()} logo={flows[0].logo} />

        <div className="max-w-5xl mx-auto px-4">
          <div id="mainContent" className="min-h-[40vh] py-8">
            <div className={`${FORM_CLASS} p-5`}>
              <Alert variant="destructive" className="mb-4">
                <AlertTitle className="flex items-center gap-2 text-base">
                  <Bug className="w-5 h-5" />
                  An unforeseen error occurred
                </AlertTitle>
                <AlertDescription>
                  <pre className="mt-2 text-sm break-words whitespace-pre-line">{errorInfo}</pre>
                </AlertDescription>
              </Alert>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
